exports = module.exports = require("../../../../../../../usr/lib/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".besidaMob-company__root--2Bs-v{-ms-flex-direction:column;-webkit-box-direction:normal;-webkit-box-orient:vertical;display:-webkit-box;display:-ms-flexbox;display:flex;flex-direction:column;height:100%}.besidaMob-company__banText--1JVf0{font-size:14px;padding:20px 40px}.besidaMob-company__unban--16BAP{background:#fff;border-top:1px solid #dfe1f0;padding:10px;position:relative}.besidaMob-company__unbanText--3d0kX{font-size:14px;margin:5px 15px 15px;text-align:center}", ""]);

// exports
exports.locals = {
	"root": "besidaMob-company__root--2Bs-v",
	"banText": "besidaMob-company__banText--1JVf0",
	"unban": "besidaMob-company__unban--16BAP",
	"unbanText": "besidaMob-company__unbanText--3d0kX"
};